import React from 'react';
import { Circle } from 'lucide-react';
export function Hero() {
  return <section className="w-full bg-cream py-16 md:py-24 px-4 overflow-hidden" data-id="element-59">
      <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-12 items-center" data-id="element-60">
        {/* Text Content */}
        <div className="flex flex-col space-y-6 md:pr-8" data-id="element-61">
          <span className="text-olive font-bold tracking-widest text-xs uppercase" data-id="element-62">
            Programa de Activación Lectora · 21 Días
          </span>

          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-dark leading-tight" data-id="element-63">
            Si tu hijo evita leer, no es falta de inteligencia.{' '}
            <span className="italic font-normal" data-id="element-64">
              Es que nadie activó el proceso en el orden correcto.
            </span>
          </h1>

          <p className="text-lg md:text-xl text-olive/90 font-sans leading-relaxed" data-id="element-65">
            Un programa amoroso y estructurado para acompañarlo en casa durante
            21 días — dedicando solo 10 minutos por día.
          </p>

          <ul className="space-y-3 mt-4" data-id="element-66">
            {['Sin presión', 'Sin improvisar', 'Sin convertir la lectura en pelea'].map((item, index) => <li key={index} className="flex items-center space-x-3" data-id="element-67">
                <Circle className="w-3 h-3 text-olive fill-olive" data-id="element-68" />
                <span className="text-dark font-medium text-lg" data-id="element-69">{item}</span>
              </li>)}
          </ul>

          <div className="pt-2" data-id="element-70">
            <a href="https://www.gaiadigitalpro.com/checkouts/cn/hWN91detKUA3JZvySec9CenJ/es-ar?_r=AQABrOvx_mroREqaZDGTff6UkVA7_iuSpYNGcQFEgzuoo40&preview_theme_id=163059597347" target="_blank" rel="noopener noreferrer" className="inline-block hover:bg-terracotta-light text-white font-serif text-xl px-12 py-5 rounded-full shadow-lg hover:shadow-xl transition-all transform hover:-translate-y-1 bg-[#6FC628]" data-id="element-71">
              Quiero activar la lectura en casa
            </a>
          </div>
        </div>

        {/* Image Content */}
        <div className="relative" data-id="element-72">
          <div className="absolute -inset-4 bg-gold/10 rounded-full blur-3xl opacity-50 -z-10" data-id="element-73"></div>
          <img src="https://cdn.magicpatterns.com/uploads/rZgCfdLBUukTRj3BxSFS7t/mockup_final_bajo.webp" alt="Programa de Activación Lectora Mockup" className="w-full h-auto rounded-2xl shadow-xl transform hover:scale-[1.02] transition-transform duration-500" data-id="element-74" />
        </div>
      </div>
    </section>;
}